/**
 元素平滑上升

 main.js 使用全局指令：
 import vSlideIn from "./plugins/tools/vSildeIn"
 Vue.directive('sliden-in',vSlideIn)
 页面使用：
 <div v-siled-in>元素</div>

 注意页面滑动的元素距离底部需要预留${DISTANCE}的高度，防止页面出现多余的滚动条。
 至于有什么好的处理办法，暂时没想到，这里先留个注释吧。
 **/

const DISTANCE = 150;
const DURATION = 1000;
const animationMap = new WeakMap()
const ob = new IntersectionObserver((entries) => {
  for (const entry of entries) {
    if (entry.isIntersecting) {
      const animation = animationMap.get(entry.target)
      animation.play()
      ob.unobserve(entry.target)
    }
  }
});

//判断元素是否在视口
function isBelowViewport(el) {
  const rect = el.getBoundingClientRect()
  return rect.top > window.innerHeight
}

export default {
  inserted(el) {
    if (!isBelowViewport(el)) {
      return
    }
    const animation = el.animate(
      [{
        transform: `translateY(${DISTANCE}px)`,
        opacity: 0.5
      },
        {
          transform: 'translateY(0)',
          opacity: 1
        }],
      {
        duration: DURATION,
        easing: 'ease'
      })
    animation.pause()
    animationMap.set(el, animation)
    ob.observe(el)
  },
  unbind(el) {
    ob.unobserve(el)
  }
}



// WEBPACK FOOTER //
// ./src/plugins/tools/vSildeIn.js